import { useParams, Link, useNavigate } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import ConsultaGetOne from '../api/consultaGetOne';
import React, { useEffect, useState } from "react";
import CancelarConsulta from '../api/cancelarConsulta';

function Consulta() {
    let { fecha, horario } = useParams();
    const [consulta, setConsulta] = useState(null);
    const [auth, setAuth] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        ConsultaGetOne(fecha, horario)
            .then(res => res.json())
            .then(res => {
                // LOG 1: Ver la respuesta completa del servidor
                console.log("1. Respuesta completa del servidor:", res);

                if (res.auth === true && res.consultas?.lista?.length > 0) {
                    const data = res.consultas.lista[0]; 
                    
                    // LOG 2: Este es el más importante. Ver qué hay dentro de la primera consulta
                    console.log("2. Contenido de 'data' (lista[0]):", data);
                    
                    setConsulta(data);
                    setAuth(true);
                } else {
                    console.warn("No se encontró la consulta o auth es false");
                    setAuth(false);
                }
            })
            .catch(err => {
                console.error("Error en fetch:", err);
                setAuth(false);
            });
    }, [fecha, horario]);

    const volver = () => navigate("/agenda");

    async function cancelar() {
        try {
            const response = await CancelarConsulta(fecha, horario);

            // Si la sesión expiró o no está logueado, el servidor tira 401
            if (response.status === 401 || response.status === 403) {
                alert("Tu sesión ha expirado o no tienes permisos. Por favor, vuelve a ingresar.");
                navigate("/login"); // O a donde manejes el acceso
                return;
            }

            const res = await response.json();

            if (res.auth === true) {
                // Si el borrado fue exitoso
                navigate("/cancelar");
            } else {
                // Si el servidor respondió pero dijo que no (ej: la consulta no existe o no es suya)
                alert(res.message || "No tiene permiso para eliminar esta consulta");
            }

        } catch (error) {
            console.error("Error al cancelar:", error);
            alert("Ocurrió un error de conexión al intentar eliminar la consulta.");
        }
    }

    // --- PROCESAMIENTO DE DATOS (Solo si existe consulta) ---

    // 1. Mapeo de campos de la Clase (Mayúsculas según tu modelo)
    const nombre = consulta?.Nombre || "Sin nombre";
    const apellido = consulta?.Apellido || "";
    const telefono = consulta?.Telefono || consulta?.Tel || "No registrado";
    const tipoVal = consulta?.Tipo;
    const especieVal = consulta?.Especie;

    // 2. Traducción de Servicio
    let tipoYEspecie = "Consulta general";
    if (tipoVal == 1) {
        tipoYEspecie = especieVal == 1 ? "Castración de gato" : "Castración de perro";
    } else if (tipoVal == 2) {
        tipoYEspecie = especieVal == 1 ? "Consulta de preñez de gato" : "Consulta de preñez de perro";
    }

    // 3. Formato de Hora
    const horasDisponibles = {
        "1": "11:00 hs",
        "2": "12:00 hs",
        "3": "13:00 hs"
    };
    const horaTexto = horasDisponibles[horario] || "Hora no definida";

    // 4. Formato de Fecha y Día
    const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    let date = new Date(fecha);
    date.setDate(date.getDate() + 1); 
    const dayWord = diasSemana[date.getDay()];

    // --- RENDERIZADO ---

    if (auth === true && consulta) {
        return (
            <>
                <Header active="Agenda" />
                <div className="consulta">
                    <h1>Detalle de Consulta</h1>
                    
                    {/* Mostramos los datos procesados arriba */}
                    <h2>{nombre} {apellido}</h2>
                    <h2>Tel: {telefono}</h2>
                    
                    <hr />
                    
                    <h3>Fecha: {dayWord} {fecha}</h3>
                    <h3>Hora: {horaTexto}</h3>
                    <h3>Servicio: {tipoYEspecie}</h3>
                    
                    <div className="contenedor-botones">
                        <button onClick={cancelar} className="btn-consulta btn-cancelar">
                            Cancelar Consulta
                        </button>
                        <button onClick={volver} className="btn-consulta btn-volver">
                            Volver
                        </button>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="container text-center py-5">
                <h2 className="mb-4">Cargando información...</h2>
                <button onClick={volver} className='volverIndex btn btn-primary'>
                    Volver al Inicio
                </button>
            </div>
            <Footer />
        </>
    );
}

export default Consulta;